import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import i18n from './i18n/i18n';
import store from './redux/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router } from "react-router-dom";

import './index.css';
import './assets/css/modal.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Router><div className='max-w-[1700px] m-auto select-none'><App /></div></Router>
      </I18nextProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();